<template>
  <validation-observer v-slot="{ passes }">
    <b-form @submit.stop.prevent="passes(submitPost)">
      <validation-provider
        name="title"
        v-slot="validationContext"
        :rules="{ required: true, max: 100 }"
      >
        <b-form-group :label="trans('community.post_title')" label-for="title" class="mb-0">
          <b-form-textarea
            id="title"
            v-model="formData.title"
            rows="2"
            max-rows="6"
            :state="getValidationState(validationContext)"
          ></b-form-textarea>
          <b-form-invalid-feedback id="title">{{
            validationContext.errors[0]
          }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
      <div class="d-flex justify-content-end caption pt-1">
        {{ trans("community.add.write_post_title_helper") }}
      </div>
      <b-form-group>
        <b-form-radio-group
          id="radio-group-1"
          v-model="formData.color_bkg_title"
          name="radio-options"
          buttons
          button-variant="danger"
        >
          <template v-for="option in options">
            <gradient-option :option="option" :key="option.value" />
          </template>
        </b-form-radio-group>
      </b-form-group>
      <validation-provider
        name="description"
        v-slot="validationContext"
        :rules="{ required: true, max: 250 }"
      >
        <b-form-group
          :label="trans('community.post_description')"
          label-for="description"
          class="mb-0"
        >
          <b-form-textarea
            id="description"
            v-model="formData.description"
            rows="3"
            max-rows="6"
            :state="getValidationState(validationContext)"
          />
          <b-form-invalid-feedback
            id="description"
            :state="getValidationState(validationContext)"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </b-form-group>
      </validation-provider>
      <div class="d-flex justify-content-end caption pt-1">
        {{ trans("community.add.write_post_description_helper") }}
      </div>
      <b-form-checkbox
        id="private"
        class="caption mb-4 pt-2 private-checkbox"
        v-model="formData.private"
        name="private"
        :value="1"
        :unchecked-value="0"
      >
        {{ trans("community.add.not_show_to_other") }}
      </b-form-checkbox>
      <div class="d-flex justify-content-end">
        <b-button
          variant="link"
          class="text-secondary"
          @click="$emit('skip-publishing')"
          v-if="$router.currentRoute.name === 'moduleSharing'"
        >
          {{ trans("community.not_now") }}
        </b-button>
        <b-button
          type="submit"
          variant="secondary"
          ref="postButton"
          v-bind:class="loading ? 'disabled' : ''"
        >
          {{ trans("community.publish") }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import GradientOption from "../../molecules/GradientOption";
import validationMixin from "../../mixins/validationMixin";
import { mapGetters } from "vuex";

export default {
  name: "CreatePostForm",
  props: {
    postData: Object,
  },
  components: { GradientOption },
  data() {
    return {
      formData: {
        title: "",
        description: "",
        color_bkg_title: "1",
        private: 0,
        id: null,
        is_room_post: 0,
        title_locale: "",
        description_locale: "",
      },
      options: [
        { text: "color-1", value: "1" },
        { text: "color-2", value: "2" },
        { text: "color-3", value: "3" },
        { text: "color-4", value: "4" },
        { text: "color-5", value: "5" },
        { text: "color-6", value: "6" },
        { text: "color-7", value: "7" },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      locale: "user/getLocale",
    }),
  },
  methods: {
    submitPost() {
      this.loading = true;
      this.formData.title_locale = this.locale;
      this.formData.description_locale = this.locale;

      if (this.postData === undefined) {
        this.$emit("onPostCreate", this.formData);
        trackEvent("PublishThePost", {});
      } else {
        this.$emit("onEditedPost", this.formData);
      }
    },
  },
  mounted() {
    if (this.postData !== undefined) {
      this.formData.title = this.postData.title;
      this.formData.description = this.postData.description;
      this.formData.color_bkg_title = this.postData.color_bkg_title;
      this.formData.private = this.postData.private;
      this.formData.id = this.postData.id;
      this.formData.is_room_post = this.postData.is_room_post;
      this.formData.title_locale = this.locale;
      this.formData.description_locale = this.locale;
    }
  },
  mixins: [validationMixin],
};
</script>

<style scoped lang="scss">
::v-deep .private-checkbox {
  &.custom-checkbox {
    .custom-control-label {
      cursor: pointer;
      &:before {
        top: 0;
      }
      &:after {
        top: 3px;
        left: -19px;
        width: 10px;
        height: 10px;
        border-radius: 3px;
      }
    }
  }
}
</style>
